import { Link, useLocation, Navigate } from "react-router-dom";
import { CheckCircle2, QrCode, Barcode, Clock } from "lucide-react";
import { brl } from "@/lib/api";
import { toast } from "sonner";

export default function OrderSuccess() {
  const { state } = useLocation();
  const order = state?.order;
  // Sem pedido no state (recarregou a página / entrou direto): não há o que confirmar.
  // Manda para "Meus pedidos", onde estão os detalhes reais e o pagamento pendente.
  if (!order) return <Navigate to="/conta/pedidos" replace />;
  const charge = order?.charge;
  /* Pendente é quando AINDA FALTA algo do cliente — não é "houve cobrança".
  
     Era `!!charge`, e isso quebrava justamente o caso que funciona melhor: o
     cartão é aprovado na hora, a cobrança existe com status `paid`, e a página
     dizia "Quase lá — conclua o pagamento" sem oferecer nada para pagar. O
     cliente já tinha pago e ficava procurando o que fazer.
  
     PIX e boleto continuam pendentes de verdade: têm código ou boleto para o
     cliente resolver depois. */
  const pending = !!charge && charge.status !== "paid";

  const copy = (text) => { navigator.clipboard?.writeText(text); toast.success("Copiado!"); };

  return (
    <div className="max-w-2xl mx-auto px-6 py-16 text-center">
      {pending ? <Clock size={56} className="text-amber-500 mx-auto mb-4" /> : <CheckCircle2 size={56} className="text-emerald-500 mx-auto mb-4" />}
      <h1 className="font-heading text-3xl font-semibold text-slate-900" data-testid="order-success-title">
        {pending ? "Quase lá — conclua o pagamento" : "Pedido confirmado!"}
      </h1>
      {/* Cartão aprovado: dizer que foi aprovado. Sem isto a página fica igual à
          do pedido em modo simulado, e o cliente não sabe se a compra saiu. */}
      {charge?.status === "paid" && (
        <p className="mt-2 text-sm text-emerald-600 font-medium" data-testid="order-charge-approved">
          Pagamento aprovado.
        </p>
      )}

      {order && (
        <div className="mt-6 bg-white border border-slate-200 rounded-xl p-6 text-left">
          <p className="text-sm text-slate-500">Número do pedido</p>
          <p className="font-mono font-semibold text-lg text-slate-900" data-testid="order-success-number">{order.number}</p>
          <div className="mt-3 flex justify-between text-sm">
            <span className="text-slate-600">{pending ? "Total a pagar" : "Total pago"} ({order.payment_method})</span>
            <span className="font-mono font-semibold" data-testid="order-success-total">{brl(order.total)}</span>
          </div>

          {charge?.qr_code && (
            <div className="mt-5 border-t border-slate-100 pt-5 text-center" data-testid="order-charge-pix">
              <p className="text-sm font-semibold text-slate-700 flex items-center justify-center gap-2 mb-3"><QrCode size={16} /> Pague com PIX</p>
              {charge.qr_code_url && <img src={charge.qr_code_url} alt="QR Code PIX" className="w-48 h-48 mx-auto border border-slate-200 rounded-lg" />}
              <button onClick={() => copy(charge.qr_code)} className="mt-3 text-xs text-brand-600 font-semibold hover:underline break-all">Copiar código PIX (copia e cola)</button>
            </div>
          )}
          {charge?.boleto_url && (
            <div className="mt-5 border-t border-slate-100 pt-5 text-center" data-testid="order-charge-boleto">
              <p className="text-sm font-semibold text-slate-700 flex items-center justify-center gap-2 mb-3"><Barcode size={16} /> Boleto bancário</p>
              <a href={charge.boleto_url} target="_blank" rel="noreferrer" className="inline-block bg-slate-800 hover:bg-slate-900 text-white text-sm font-semibold px-5 py-2 rounded-lg">Abrir boleto</a>
              {charge.boleto_line && <button onClick={() => copy(charge.boleto_line)} className="block mx-auto mt-2 text-xs text-brand-600 font-semibold hover:underline">Copiar linha digitável</button>}
            </div>
          )}
        </div>
      )}

      <div className="mt-8 flex justify-center gap-4">
        <Link to="/conta/pedidos" data-testid="order-success-view-orders" className="bg-brand-600 hover:bg-brand-700 text-white font-semibold px-6 py-3 rounded-lg">Meus pedidos</Link>
        <Link to="/produtos" data-testid="order-success-continue" className="border border-slate-300 text-slate-700 font-medium px-6 py-3 rounded-lg hover:border-slate-500">Continuar comprando</Link>
      </div>
    </div>
  );
}
